export default "__VITE_ASSET__pygbFeQ4__"